// src/components/sections/Benefit1.js

export default function Benefit1() {
	return (
		<div className="tf-widget-benefit background-black">
			<div className="themeflat-container">
				<div
					className="tf-benefit"
					style={{
						// Adjust spacing as needed
						padding: "40px 0",
					}}
				>
					<div className="title-box-v2 center-title-box title-large">
						<span className="sub-title wow fadeInUp animated">
							Total Football Development
						</span>
						<h2 className="title-section wow fadeInUp animated">
							6 Key Reasons to Choose TFD
						</h2>
					</div>

					<div
						className="benefit-wrap-content"
						style={{ maxWidth: "1200px", margin: "0 auto" }}
					>
						<div className="row align-items-center">
							{/* LEFT Column => 16:9 thumbnail with play overlay */}
							<div className="col-md-6 benefit-center">
								{/* Aspect ratio container => 16:9 (56.25% = 9/16) */}
								<div
									style={{
										position: "relative",
										width: "100%",
										paddingTop: "56.25%", // 16:9 ratio container
										overflow: "hidden",
									}}
								>
									{/* Link to the .mp4 file */}
									{/* <a
										href="https://pub-f9ab9d721e124a068775022b9a315fad.r2.dev/August%202024%20TFD%20Promo%20video%201.mp4"
										target="_blank"
										rel="noreferrer"
										style={{
											position: "absolute",
											top: 0,
											left: 0,
											width: "100%",
											height: "100%",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											cursor: "pointer",
										}}
									> */}
									{/* Here is your REAL image thumbnail (jpg/png), not the .mp4 link */}
									<img
										src="/images/WhatsApp Image 2025-01-26 at 5.34.55 PM.jpeg"
										alt="TFD Video Thumbnail"
										style={{
											position: "absolute",
											top: 0,
											left: 0,
											width: "100%",
											height: "100%",
											objectFit: "cover",
											borderRadius: 0,
										}}
									/>

									{/* PLAY ICON OVERLAY */}
									{/* </a> */}
								</div>
							</div>

							{/* RIGHT Column => The 6 bullet points */}
							<div className="col-md-6">
								{/* #1 */}
								<div
									className="benefit-item"
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: "20px",
									}}
								>
									<div
										className="benefit-number"
										style={{ marginRight: "10px" }}
									>
										<span className="number wow zoomIn animated">1</span>
									</div>
									<div className="benefit-content">
										<h6 className="title-benefit wow fadeInLeft animated">
											Expert Coaching Team
										</h6>
										<p className="description-benefit wow fadeInLeft animated">
											Our coaches bring years of professional and youth football
											experience, delivering personalized training to help every
											player reach their full potential.
										</p>
									</div>
								</div>

								{/* #2 */}
								<div
									className="benefit-item"
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: "20px",
									}}
								>
									<div
										className="benefit-number"
										style={{ marginRight: "10px" }}
									>
										<span className="number wow zoomIn animated">2</span>
									</div>
									<div className="benefit-content">
										<h6 className="title-benefit wow fadeInLeft animated">
											Comprehensive Player Development
										</h6>
										<p className="description-benefit wow fadeInLeft animated">
											We nurture technical, tactical, and mental growth both on
											and off the pitch—ensuring our players become well-rounded
											athletes and individuals.
										</p>
									</div>
								</div>

								{/* #3 */}
								<div
									className="benefit-item"
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: "20px",
									}}
								>
									<div
										className="benefit-number"
										style={{ marginRight: "10px" }}
									>
										<span className="number wow zoomIn animated">3</span>
									</div>
									<div className="benefit-content">
										<h6 className="title-benefit wow fadeInLeft animated">
											Pathways to Success
										</h6>
										<p className="description-benefit wow fadeInLeft animated">
											Our connections in the football world provide
											opportunities for trials at some of Europe’s biggest
											clubs—opening doors for truly ambitious players.
										</p>
									</div>
								</div>

								{/* #4 */}
								<div
									className="benefit-item"
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: "20px",
									}}
								>
									<div
										className="benefit-number"
										style={{ marginRight: "10px" }}
									>
										<span className="number wow zoomIn animated">4</span>
									</div>
									<div className="benefit-content">
										<h6 className="title-benefit wow fadeInLeft animated">
											Building Lifelong Skills
										</h6>
										<p className="description-benefit wow fadeInLeft animated">
											Through discipline, teamwork, and leadership, we empower
											players to succeed both on the pitch and in life.
										</p>
									</div>
								</div>

								{/* #5 */}
								<div
									className="benefit-item"
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: "20px",
									}}
								>
									<div
										className="benefit-number"
										style={{ marginRight: "10px" }}
									>
										<span className="number wow zoomIn animated">5</span>
									</div>
									<div className="benefit-content">
										<h6 className="title-benefit wow fadeInLeft animated">
											Age-Appropriate Programs
										</h6>
										<p className="description-benefit wow fadeInLeft animated">
											From beginners to advanced players, our training is
											carefully tailored to each age group and skill level for
											maximum growth.
										</p>
									</div>
								</div>

								{/* #6 */}
								<div
									className="benefit-item"
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: "20px",
									}}
								>
									<div
										className="benefit-number"
										style={{ marginRight: "10px" }}
									>
										<span className="number wow zoomIn animated">6</span>
									</div>
									<div className="benefit-content">
										<h6 className="title-benefit wow fadeInLeft animated">
											For the Love of the Game
										</h6>
										<p className="description-benefit wow fadeInLeft animated">
											No matter your playing history, if you love this game, we
											will make you love it even more.
										</p>
									</div>
								</div>
							</div>
							{/* End col-md-6 */}
						</div>
						{/* End row */}
					</div>
				</div>
			</div>
		</div>
	);
}
